module.exports = __webpack_public_path__ + "media/application/images/company/secondary_nav/our-ambition-e238788e520d72b288e455f3a28b4279.jpg";